import { memo } from 'react';
import { Button, List, Popconfirm, Card } from 'antd';
import ShowError from 'components/alerts/ShowError';
import { useTranslation } from 'translations';
import NotificationsItem from './NotificationsItem';

interface NotificationsMenuProps {
  notifications: any[];
  request: any;
  isClearing: boolean;
  hasMore: boolean;
  loadMore: (...args: any[]) => any;
  setDropdownVisible: (...args: any[]) => any;
  updateNotificationStatus: (...args: any[]) => any;
  clearNotifications: (...args: any[]) => any;
  deleteNotification: (...args: any[]) => any;
}

const NotificationsMenu = memo(
  ({
    notifications,
    request,
    isClearing,
    hasMore,
    loadMore,
    setDropdownVisible,
    updateNotificationStatus,
    clearNotifications,
    deleteNotification,
  }: NotificationsMenuProps) => {
    const { tC } = useTranslation('features', 'notifications');

    const clearDisabled = isClearing || !notifications.length;

    let loadMoreClick;
    if (hasMore) {
      loadMoreClick = loadMore;
    }

    return (
      <Card
        className="notification-menu"
        size="small"
        title={tC('notification', { count: 2 })}
        extra={
          <Popconfirm
            title={tC('notificationsDeleteConfirm')}
            okText={tC('notificationsDeleteButton')}
            okType="danger"
            cancelText={tC('cancelButton')}
            onConfirm={clearNotifications}
            disabled={clearDisabled}
            overlayStyle={{ zIndex: 9999 }}
            placement="bottom">
            <Button disabled={clearDisabled} type="link">
              {tC('clearAllButton')}
            </Button>
          </Popconfirm>
        }>
        <List
          size="small"
          className="notification-list"
          locale={request?.status === 'error' && { emptyText: <ShowError request={request} /> }}
          loading={request?.status === 'pending' || isClearing}
          itemLayout="horizontal"
          dataSource={notifications}
          footer={
            <Button key="loadMore" disabled={!hasMore} onClick={loadMoreClick} type="link" block>
              {tC('loadMoreButton')}
            </Button>
          }
          rowKey={(notification: any) => notification.meta.id}
          renderItem={(notification: any) => (
            <NotificationsItem
              key={notification.meta.id}
              notification={notification}
              setDropdownVisible={setDropdownVisible}
              updateNotificationStatus={updateNotificationStatus}
              deleteNotification={deleteNotification}
            />
          )}
        />
      </Card>
    );
  },
);

NotificationsMenu.displayName = 'NotificationsMenu';

export default NotificationsMenu;
